export default "__VITE_ASSET__DkkmEXJs9WY8hminGtE_uw__"